<template>
  <nav
    class="navbar navbar-expand-lg navbar-absolute"
    :class="{ 'bg-white': showMenu, 'navbar-transparent': !showMenu }"
  >
    <div class="container-fluid">
      <div class="navbar-wrapper">
        <div
          class="navbar-toggle d-inline"
          :class="{ toggled: $sidebar.showSidebar }"
        >
          <button
            type="button"
            class="navbar-toggler"
            aria-label="Navbar toggle button"
            @click="toggleSidebar"
          >
            <span class="navbar-toggler-bar bar1"></span>
            <span class="navbar-toggler-bar bar2"></span>
            <span class="navbar-toggler-bar bar3"></span>
          </button>
        </div>
        <a class="navbar-brand" href="#pablo">{{ routeName }}</a>
      </div>
      <button
        class="navbar-toggler"
        type="button"
        @click="toggleMenu"
        data-toggle="collapse"
        data-target="#navigation"
        aria-controls="navigation-index"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
      </button>

      <collapse-transition>
        <div class="collapse navbar-collapse show" v-show="showMenu">
          <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
            <base-input>
              <select
                class="form-control my-select"
                :class="showMenu ? 'white-background' : 'my-select'"
                id="filter"
                :value="selectedBookie"
                @change="onSelectedBookieChanged($event)"
              >
                <option v-for="bookie in bookies" :key="bookie" :value="bookie">
                  {{ bookie }}</option
                >
              </select>
            </base-input>
            <base-dropdown
              tag="li"
              :menu-on-right="!$rtl.isRTL"
              title-tag="a"
              class="nav-item"
              menu-classes="dropdown-navbar"
            >
              <a
                slot="title"
                href="#"
                class="dropdown-toggle nav-link"
                data-toggle="dropdown"
                aria-expanded="true"
              >
                <div class="photo">
                  <img src="img/anime3.png" />
                </div>
                <b class="caret d-none d-lg-block d-xl-block"></b>
                <p class="d-lg-none">
                  Log out
                </p>
              </a>
              <li class="nav-link">
                <a
                  href="#"
                  @click.prevent="logout()"
                  class="nav-item dropdown-item"
                  >Log out</a
                >
              </li>
              <li class="nav-link">
                <router-link to="/settings" class="nav-item dropdown-item" exact>Settings</router-link>
              </li>
            </base-dropdown>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </nav>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import Modal from "@/components/Modal";
import { mapActions, mapGetters } from "vuex";
import axios from 'axios'

export default {
  components: {
    CollapseTransition,
    Modal
  },
  computed: {
    ...mapGetters(["selectedBookie"]),
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    isRTL() {
      return this.$rtl.isRTL;
    }
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: "",
      bookies: ["Odibets", "Betika", "Ababet", "Flashscore", "1xbet", "Wezabet", "Hakibets", "Sofascore"],
    };
  },
  methods: {
    ...mapActions(["setSelectedBookie"]),
    onSelectedBookieChanged(event) {
      this.setSelectedBookie(event.target.value);
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    logout() {
      axios.get("/logout").then(response => {
          localStorage.removeItem("token");
          this.$router.replace({ path: "/login" });
      })
      .catch((error)=>{
          console.log("🚀 ~ file: Login.vue:67 ~ onSubmit ~ error", error)
          localStorage.removeItem("token");
          this.$router.replace({ path: "/login" });
      });
    }
  }
};
</script>
<style>
.my-select {
  background-color: #1e1e2e;
  color: #ffffff;
  padding: 6px 20px;
}
.my-select option {
  background-color: #1e1e2e;
  color: #ffffff;
}
.white-background {
  background-color: #ffffff;
}
</style>
